import type { TranslationKey } from "../locales";
import type { Enums, Nullable } from "../types";

/**
 * This function is used to get the warehouse zone translation key.
 */
export function getWarehouseZoneTypeTranslationKey(
	type: Nullable<Enums<"warehouseZoneType">>,
): TranslationKey {
	if (!type) return "general.loading";
	return `stock.warehouse_zone_type.${type}`;
}
